import React from 'react'
import ToastMessages from './ToastMessages'
import { Toaster } from 'sonner'

const Layout = (props) => {
  return (
    <div>

      <main>
        {props.children}
      </main>

      <Toaster
        position='top-right'
        richColors
        duration={5000} // TODO: check much seconds
        closeButton
        expand
      />

      <ToastMessages />
    </div>
  )
}

export default Layout
